module.exports = __webpack_public_path__ + "img/testimonial-debrah-nadler.a8577649.png";